module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }